var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "setTab",
      rawName: "v-setTab"
    }],
    staticClass: "fm-pcn-app",
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }